import { useWorkspaceFeatureGates } from "src/hooks/useWorkspaceFeatureGates";
import { FEATURE_FLAGS, isFeatureFlagEnabled } from "src/router/featureFlags";

// BYOK LLM credentials enablement during the flag→gate migration (AGNT-2906).
// Enabled when EITHER the legacy `byok-llm-credentials` URL feature flag is on
// OR the workspace `byok` feature gate is set. The flag arm is transitional: it
// lets the gate roll out while the flag still works, so we can migrate entitled
// workspaces onto the gate and confirm nothing relies on the flag before
// removing it in a follow-up.
export const useIsByokEnabled = (): boolean => {
  const { byokEnabled } = useWorkspaceFeatureGates();
  return isFeatureFlagEnabled(FEATURE_FLAGS.byokLlmCredentials) || byokEnabled;
};
